import React, { ReactNode, useCallback, useMemo } from 'react';

import Dropdown from '@adsk/alloy-react-dropdown';
import FormField from '@adsk/alloy-react-form-field';

import { DropdownMultiSelectProps, ScheduleFilters } from '../../types';

function ActivityCodeFilters({
  activityCodesMap,
  onChangeFilter,
  filters,
}: {
  activityCodesMap: Map<string, Set<string>>;
  onChangeFilter: (filterKey: string, values: string[]) => void;
  filters: ScheduleFilters;
}) {
  const handleSelectItemsChanges = useCallback(
    (filterKey: string, { selectedItems = [] }: DropdownMultiSelectProps) => {
      const values =
        selectedItems?.map((item) => item?.value?.toString() || '') ?? [];
      onChangeFilter(filterKey, values);
    },
    [onChangeFilter],
  );

  const activityCodeFilters = useMemo(() => {
    const filterComponents: ReactNode[] = [];
    activityCodesMap?.forEach((value: Set<string>, key: string) => {
      const options = Array.from(value).map((item) => ({
        label: item,
        value: item,
      }));
      const filterKey = `activityCode${key}`;
      const selectedItems = filters?.[filterKey]
        ? options.filter((item) =>
            (filters?.[filterKey] as string[])?.includes(item?.value),
          )
        : [];
      filterComponents.push(
        <FormField
          key={key}
          label={key}
          labelVariant={FormField.LABEL_VARIANTS.TOP}
          style={{ paddingTop: 16 }}
        >
          <Dropdown
            style={{ width: '100%' }}
            isMultiple
            items={options}
            selectedItems={selectedItems}
            onSelectedItemsChange={(changes: DropdownMultiSelectProps) =>
              handleSelectItemsChanges(filterKey, changes)
            }
          />
        </FormField>,
      );
    });
    return filterComponents;
  }, [activityCodesMap, filters, handleSelectItemsChanges]);

  return <>{activityCodeFilters}</>;
}

export default ActivityCodeFilters;
